export var Shortcode;
(function (Shortcode) {
    Shortcode["Fanclub"] = "fanclub";
    Shortcode["Follow"] = "follow";
    Shortcode["Signup"] = "signup";
    Shortcode["Supporter"] = "supporter";
    Shortcode["Tip"] = "tip";
    Shortcode["Help"] = "help";
})(Shortcode || (Shortcode = {}));
